import { take } from "../util/takePayload";
export const fromGql = (gqlItem) => take(gqlItem, 'price', 'displayPrice', 'convenienceFee', 'taxFee', 'ccFee');
//# sourceMappingURL=CheckoutBlueprintPriceBreakdown.js.map